import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Sidebar } from './components/layout/Sidebar';
import { Topbar } from './components/layout/Topbar';
import { routes } from './routes';

export default function App() {
  return (
    <BrowserRouter>
      <div className="mp-app">
        <Sidebar />
        <div className="mp-main">
          <Topbar />
          <Routes>
            {routes.map((r) => (
              <Route key={r.path} path={r.path} element={r.element} />
            ))}
          </Routes>
        </div>
      </div>
    </BrowserRouter>
  );
}
